import { render } from "./ui.cattle.io.navlink.vue?vue&type=template&id=1646532b"
import script from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js"
export * from "./ui.cattle.io.navlink.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__